// extracted by mini-css-extract-plugin
export default {"extra-wrapper":"fz6PZ","wrapper":"minhD"};